<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <v-list-item-avatar class="my-0">
      <v-icon v-if="isNoteEmpty" small>fal fa-exclamation-triangle</v-icon>
      <v-tooltip bottom v-else>
        <template v-slot:activator="{ on }">
          <v-badge left v-on="on" color="secondary">
            <template v-slot:badge>
              <v-icon small>fal fa-exclamation-triangle</v-icon>
            </template>
            <span><v-icon x-small>fa-comment-alt</v-icon></span>
          </v-badge>
        </template>
        <span>{{ printNote }}</span>
      </v-tooltip>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="!isPrintEmpty">告知事項</v-list-item-subtitle>
      <v-list-item-title v-if="isPrintEmpty">告知事項</v-list-item-title>
      <v-list-item-title v-else-if="isNoAnswer">告知事項なし</v-list-item-title>
      <v-list-item-title v-else>
        <span v-for="(item, idx) in getNoteLabelItems" :key="idx" class="caption amber pa-3 mr-1">{{ item }}</span>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-subheader>告知事項</v-subheader>
    <v-row dense justify="end">
      <div class="text-xs-right">
        <v-switch color="blue darken-2" label="告知事項なし" v-model="config.ignore" @change="ignore"></v-switch>
      </div>
    </v-row>
    <v-row dense v-if="!isIgnore">
      <v-col cols="12" class="px-3">
        <v-select chips attach multiple
          color="blue darken-2"
          label="告知事項の選択"
          v-model="form.notes.content"
          :items="getNoteItems"
          item-text="text"
          item-value="value"
          :rules="rules.notes"
        />
      </v-col>
    </v-row>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-text-field counter
          v-model="form.notes.note"
          label="告知事項の備考欄"
          maxlength="50"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'clientAboutAboutNotes',
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        ignore: false
      },
      meta: {
        notes: {
          DISEASE: '持病（定期診察が必要）',
          REFUSAL: '不登校・引きこもり',
          DISORDER: '脳疾患・心疾患・うつ病等',
          OTHERS: 'その他'
        }
      },
      form: {
        notes: {
          id: '',
          content: [],
          note: ''
        }
      },
      rules: {
        notes: [
          v => !!(v && v.length) || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.notes
      ) {
        this.$set(this.config, 'ignore', !!(this.$props.data.notes.content && this.$props.data.notes.content === 'NONE'))
        this.$set(this.form, 'notes', {
          id: '' + (this.$props.data.notes.id ? this.$props.data.notes.id : 'new_notes'),
          content: this.$props.data.notes.content ? this.$props.data.notes.content.split(',') : [],
          note: this.$props.data.notes.note ? this.$props.data.notes.note : ''
        })
      } else {
        this.$set(this.form, 'notes', {
          id: 'new_notes',
          content: [],
          note: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'notes'
        }
      })
    },
    ignore: function () {
      this.$set(this.form.notes, 'content', this.config.ignore ? ['NONE'] : [])
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['notes', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'notes'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['notes', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'notes'
      )
    },
    isIgnore () {
      return this.config.ignore
    },
    isNoAnswer () {
      return !!(
        this.$props.data &&
        this.$props.data.notes &&
        this.$props.data.notes.content &&
        this.$props.data.notes.content === 'NONE'
      )
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.notes &&
        this.$props.data.notes.content
      )
    },
    printNote () {
      return (
        this.$props.data &&
        this.$props.data.notes &&
        this.$props.data.notes.note
      ) ? this.$props.data.notes.note : ''
    },
    isNoteEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.notes &&
        this.$props.data.notes.note
      )
    },
    getNoteItems () {
      return Object.keys(this.meta.notes).map(key => {
        return {
          text: this.meta.notes[key],
          value: key
        }
      })
    },
    getNoteLabelItems () {
      return (
        this.$props.data &&
        this.$props.data.notes &&
        this.$props.data.notes.content
      ) ? this.$props.data.notes.content.split(',').map(key => {
          return (this.meta.notes[key]) ? this.meta.notes[key] : ''
        }) : []
    }
  }
}
</script>
